// extracted by mini-css-extract-plugin
export default {"container":"Sy3NQM","containerVetsNegative":"XtxnOy","containerVetsPositive":"qH0ztZ","iconItem":"u2ORAa","iconItemVetsNegative":"AHGqBj","icon":"yf8_64","iconText":"MYIf3X"};